/**
 * THIS FILE WILL WORK AS THE START UP FILE FOR THE APPLICATION
 * THIS WILL CONTAIN THE HEADER AND FOOTER AND COMMON ROUTE IMPORT
 */
import React from 'react';
// import Header from 'LIBRARY/Header/Header';
import RoutesSetup from 'LIBRARY/Routes/Routes';
import Footer from 'LIBRARY/Footer/Footer';
import config from 'config'
import { Route } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { ToastContainer } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';
import HeaderWorkspace from 'LIBRARY/HeaderWorkspace/Header';
// import MaintenanceBlocker from 'LIBRARY/CommonResources/MaintenanceBlocker/MaintenanceBlocker';

class App extends React.Component {
  render() {
    if (config.instructorInfo == undefined || config.instructorInfo == '') {
      return (
        <div className="App">
        </div>
      );
    }
    else {
      return (
        <SnackbarProvider maxSnack={3}>
          <div className="App">
            {/* <MaintenanceBlocker /> */}
            {/* <Header /> */}
            <HeaderWorkspace />
            <div id="routeSetup"><RoutesSetup /></div>
            <br />
            <br />
            <br />
            <Footer />
            <ToastContainer
              position="bottom-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />

          </div>
        </SnackbarProvider>
      );
    }
  }

}

export default App;
